import { useMemo } from 'react';
import { ITicketStatus } from '../interfaces/support';

export const useTicketStatusColors = (status: ITicketStatus) => {
	const className = useMemo(() => {
		switch (status) {
			case 'in_progress':
				return 'bg-primary-selected text-primary-main';
			case 'answered':
				return 'bg-success-selected text-success-main';
			case 'new':
				return 'bg-secondary-selected text-secondary-dark';
			case 'pending':
				return 'bg-warning-selected text-warning-main';
			case 'closed':
				return 'bg-error-selected text-error-main';
			default:
				return '';
		}
	}, [status]);

	return className;
};
